"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Label = _interopRequireDefault(require("../Label"));

var _utils = _interopRequireDefault(require("../utils/utils"));

var _Checkbox = _interopRequireDefault(require("./Checkbox.style"));

var _dec, _class;

let Checkbox = (_dec = (0, _reactJss.default)(_Checkbox.default), _dec(_class = class Checkbox extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange() {
    const {
      id,
      value,
      visibility,
      required,
      onChange
    } = this.props;
    if (visibility === 'disabled') return;
    const valueF = !_utils.default.tryToBool(value);
    const error = required && !valueF;
    onChange({
      id,
      value: valueF,
      error
    });
  }

  render() {
    const _this$props = this.props,
          {
      id,
      classes,
      className,
      error,
      visibility,
      value,
      children,
      helperText,
      unspaced,
      dataTestId
    } = _this$props,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["id", "classes", "className", "error", "visibility", "value", "children", "helperText", "unspaced", "dataTestId"]);

    const uniqId = _utils.default.random();

    const isChecked = _utils.default.tryToBool(value);

    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      id: id,
      className: (0, _clsx.default)(className, classes.checkbox, {
        checked: isChecked
      }, {
        error: !!error
      }, {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      }, {
        unspaced
      }),
      "data-testid": dataTestId ? `${dataTestId}-container` : undefined
    }, _utils.default.omit(rest, ['onChange'])), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.content
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: (0, _clsx.default)(classes.input, {
        error
      }),
      type: "checkbox",
      value: isChecked,
      id: `id-${uniqId}`,
      onChange: this.handleOnChange,
      "data-testid": dataTestId
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.icon, {
        error
      }),
      type: isChecked ? 'checkbox_on' : 'checkbox_off',
      error: error,
      size: "medium",
      color: "currentColor"
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: classes.label,
      htmlFor: `id-${uniqId}`
    }, children)), helperText && /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.helperText, {
        error
      }),
      value: helperText,
      fontSize: "small",
      error: error
    }));
  }

}) || _class);
Checkbox.defaultProps = {
  visibility: 'visible',
  error: false,
  value: false,
  onChange: () => {}
};
var _default = Checkbox;
exports.default = _default;